import { render, staticRenderFns } from "./ReviewBoosterConfig.vue?vue&type=template&id=b66ab40e&scoped=true&"
import script from "./ReviewBoosterConfig.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterConfig.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterConfig.vue?vue&type=style&index=0&id=b66ab40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ab40e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
